import { z } from 'zod';

/** Valeurs du formulaire « Email oublié ». */
export interface OubliEmailValues {
    nom?: string;
    belair_id?: string;
    date_naissance?: Date | null;
    email?: string;
}

const REQUIRED_FIELDS = ['date_naissance', 'nom', 'belair_id', 'email'] as const;

export const oubliEmailSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;

    for (const field of REQUIRED_FIELDS) {
        if (!v[field]) ctx.addIssue({ code: 'custom', path: [field], message: 'Le champ est obligatoire' });
    }
});
